const LAST_RELOAD_STORAGE_KEY = "vite-preload-error-reload-at";
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
const RELOAD_COOLDOWN_MS = 60 * 1000;

interface RecoveryDependencies {
  now(): number;
  reload(): void;
  storage: Pick<Storage, "getItem" | "setItem">;
}

const getBrowserDependencies = (): RecoveryDependencies => ({
  now: Date.now,
  reload: () => window.location.reload(),
  storage: window.sessionStorage,
});

export const recoverFromDynamicImportError = (
  event: Event,
  dependencies = getBrowserDependencies()
) => {
  const currentTime = dependencies.now();

  try {
    const storedReloadTime = dependencies.storage.getItem(
      LAST_RELOAD_STORAGE_KEY
    );
    const lastReloadTime = Number(storedReloadTime);

    if (
      storedReloadTime !== null &&
      Number.isFinite(lastReloadTime) &&
      currentTime - lastReloadTime < RELOAD_COOLDOWN_MS
    ) {
      return false;
    }

    dependencies.storage.setItem(LAST_RELOAD_STORAGE_KEY, String(currentTime));
  } catch {
    // Without a persistent guard, reloading could trap the browser in a loop.
    return false;
  }

  event.preventDefault();
  dependencies.reload();

  return true;
};

export const registerDynamicImportRecovery = () => {
  if (typeof window === "undefined") return;

  window.addEventListener("vite:preloadError", recoverFromDynamicImportError);
};
